import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import API from "../Context/api";

function ViewInvoice() {
  const { id } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const response = await API.get(`/invoices/${id}`);
        console.log(response);
        setInvoice(response.data);
      } catch (err) {
        setError(err.message || "Failed to fetch invoice");
      } finally {
        setLoading(false);
      }
    };
    fetchInvoice();
  }, [id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error) return <p className="text-center text-red-500">Error: {error}</p>;

  if (!invoice)
    return <p className="text-center text-gray-500">No invoice found</p>;

  const {
    invoiceDetails: {
      companyName = "",
      companyTIN = "",
      address = "",
      phone = "",
      email = [],
      description = "",
      taxInvoiceNo = "",
      date = "",
      client = "",
      totalAmount = 0,
      vat = 0,
      amountInWords = "",
      items = [],
    } = {},
  } = invoice;

  const subtotal = items
    .reduce((sum, item) => sum + (item.total || 0), 0)
    .toLocaleString();

  const handlePrint = () => {
    window.print();
  };

  const formattedDate = new Date(date).toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    // <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg my-8">
    //   {/* Header */}
    //   <div className="text-center mb-8 border-b pb-4">
    //     <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight">
    //       {companyName}
    //     </h1>
    //     <p className="text-sm text-gray-600 mt-2 leading-relaxed">
    //       TIN: {companyTIN} | {address}, Tel: {phone}
    //       <br />
    //       Email: {email.join(", ")}
    //     </p>
    //     <p className="text-sm text-gray-500 italic mt-1">{description}</p>
    //   </div>

    //   {/* Invoice Title */}
    //   <div className="flex justify-between items-center mb-6">
    //     <h2 className="text-2xl font-semibold text-gray-800 uppercase tracking-wide">
    //       Tax Invoice
    //     </h2>
    //     <div className="text-right">
    //       <p className="text-sm text-gray-700">
    //         No. <span className="font-bold text-gray-900">{taxInvoiceNo}</span>
    //       </p>
    //       <p className="text-sm text-gray-700">
    //         Date:{" "}
    //         <span className="font-bold text-gray-900">{formattedDate}</span>
    //       </p>
    //     </div>
    //   </div>

    //   {/* Client Info */}
    //   <div className="mb-6 bg-gray-50 p-4 rounded-md">
    //     <p className="text-lg font-medium text-gray-800">
    //       M/s <span className="font-semibold">{client}</span>
    //     </p>
    //   </div>

    //   {/* Combined Table */}
    //   <div className="mb-6">
    //     <p className="text-sm text-gray-600 mb-3">Accounts are due on demand</p>
    //     <div className="overflow-x-auto">
    //       <table className="w-full border-collapse bg-white rounded-lg">
    //         <thead>
    //           <tr className="bg-gray-100 text-gray-700 text-sm uppercase tracking-wider">
    //             <th className="p-3 text-left font-medium">Qty</th>
    //             <th className="p-3 text-left font-medium">Particulars</th>
    //             <th className="p-3 text-left font-medium">Rate</th>
    //             <th className="p-3 text-left font-medium">Amount (UGX)</th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {items.map((item, index) => (
    //             <tr
    //               key={index}
    //               className="border-b hover:bg-gray-50 transition-colors duration-150"
    //             >
    //               <td className="p-3 text-gray-700">{item.quantity}</td>
    //               <td className="p-3 text-gray-700">{item.particulars}</td>
    //               <td className="p-3 text-gray-700">{item.rate}</td>
    //               <td className="p-3 text-gray-700 text-right">{item.total}</td>
    //             </tr>
    //           ))}
    //           {/* Subtotal Row */}
    //           <tr className="border-t bg-gray-50">
    //             <td
    //               colSpan="3"
    //               className="p-3 text-left font-semibold text-gray-800"
    //             >
    //               Subtotal
    //             </td>
    //             <td className="p-3 text-right text-gray-800">{subtotal}</td>
    //           </tr>
    //           {/* VAT Row */}
    //           <tr className="border-t">
    //             <td
    //               colSpan="3"
    //               className="p-3 text-left font-semibold text-gray-800"
    //             >
    //               VAT @ 18%
    //             </td>
    //             <td className="p-3 text-right text-gray-800">{vat}</td>
    //           </tr>
    //           {/* TOTAL Row */}
    //           <tr className="border-t bg-gray-100">
    //             <td
    //               colSpan="3"
    //               className="p-3 text-left font-bold text-gray-900 uppercase"
    //             >
    //               TOTAL
    //             </td>
    //             <td className="p-3 text-right font-bold text-gray-900">
    //               {totalAmount.toLocaleString()}
    //             </td>
    //           </tr>
    //         </tbody>
    //       </table>
    //     </div>
    //   </div>

    //   {/* Amount in Words */}
    //   <div className="mb-6 p-4 bg-gray-50 rounded-md">
    //     <p className="text-sm text-gray-600">Amount in words:</p>
    //     <p className="font-semibold text-gray-800 uppercase">{amountInWords}</p>
    //   </div>

    //   {/* Signature */}
    //   <div className="text-right mb-6">
    //     <p className="text-gray-700">Signed: _____________________</p>
    //     <p className="text-sm text-gray-600 mt-1">for: {companyName}</p>
    //   </div>

    //   {/* Print Button */}
    //   <button
    //     onClick={handlePrint}
    //     className="w-full sm:w-auto bg-blue-600 text-white px-6 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200 print:hidden"
    //   >
    //     Print Invoice
    //   </button>
    // </div>
    <div className="max-w-3xl mx-auto p-4 sm:p-6 bg-white border border-gray-300 rounded-lg shadow-sm my-8">
      {/* Header */}
      <div className="text-center mb-6 border border-gray-200 rounded-md p-4">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight">
          <img
            src="/images/logo.png"
            alt="Company Logo"
            className="h-20 w-20 mr-2 inline-block"
          />
          {companyName}
        </h1>
        <p className="text-xs sm:text-sm text-gray-600 mt-2 leading-relaxed">
          TIN: {companyTIN} | {address}, Tel: {phone}
          <br />
          Email: {email.join(", ")}
        </p>
        <p className="text-xs sm:text-sm text-gray-500 italic mt-1">
          {description}
        </p>
      </div>

      {/* Invoice Title */}
      <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-3">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 uppercase tracking-wide">
          Tax Invoice
        </h2>
        <div className="text-right">
          <p className="text-xs sm:text-sm text-gray-700">
            No. <span className="font-bold text-gray-900">{taxInvoiceNo}</span>
          </p>
          <p className="text-xs sm:text-sm text-gray-700">
            Date:{" "}
            <span className="font-bold text-gray-900">{formattedDate}</span>
          </p>
        </div>
      </div>

      {/* Client Info */}
      <div className="mb-6 bg-gray-50 p-3 sm:p-4 rounded-md border border-gray-200">
        <p className="text-base sm:text-lg font-medium text-gray-800">
          M/s <span className="font-semibold">{client}</span>
        </p>
      </div>

      {/* Combined Table */}
      <div className="mb-6">
        <p className="text-xs sm:text-sm text-gray-600 mb-3">
          Accounts are due on demand
        </p>
        <div className="overflow-x-auto border border-gray-200 rounded-md">
          <table className="w-full border-collapse bg-white">
            <thead>
              <tr className="bg-gray-100 text-gray-700 text-xs sm:text-sm uppercase tracking-wider">
                <th className="p-2 sm:p-3 text-left font-medium border-b border-gray-200">
                  Qty
                </th>
                <th className="p-2 sm:p-3 text-left font-medium border-b border-gray-200">
                  Particulars
                </th>
                <th className="p-2 sm:p-3 text-left font-medium border-b border-gray-200">
                  Rate
                </th>
                <th className="p-2 sm:p-3 text-right font-medium border-b border-gray-200">
                  Amount (UGX)
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150"
                >
                  <td className="p-2 sm:p-3 text-gray-700 text-xs sm:text-sm">
                    {item.quantity}
                  </td>
                  <td className="p-2 sm:p-3 text-gray-700 text-xs sm:text-sm">
                    {item.particulars}
                  </td>
                  <td className="p-2 sm:p-3 text-gray-700 text-xs sm:text-sm">
                    {item.rate}
                  </td>
                  <td className="p-2 sm:p-3 text-gray-700 text-xs sm:text-sm text-right">
                    {item.total}
                  </td>
                </tr>
              ))}
              {/* Subtotal Row */}
              <tr className="border-t border-gray-200 bg-gray-50">
                <td
                  colSpan="3"
                  className="p-2 sm:p-3 text-left font-semibold text-gray-800 text-xs sm:text-sm"
                >
                  Subtotal
                </td>
                <td className="p-2 sm:p-3 text-right text-gray-800 text-xs sm:text-sm">
                  {subtotal}
                </td>
              </tr>
              {/* VAT Row */}
              <tr className="border-t border-gray-200">
                <td
                  colSpan="3"
                  className="p-2 sm:p-3 text-left font-semibold text-gray-800 text-xs sm:text-sm"
                >
                  VAT @ 18%
                </td>
                <td className="p-2 sm:p-3 text-right text-gray-800 text-xs sm:text-sm">
                  {vat}
                </td>
              </tr>
              {/* TOTAL Row */}
              <tr className="border-t border-gray-200 bg-gray-100">
                <td
                  colSpan="3"
                  className="p-2 sm:p-3 text-left font-bold text-gray-900 uppercase text-xs sm:text-sm"
                >
                  TOTAL
                </td>
                <td className="p-2 sm:p-3 text-right font-bold text-gray-900 text-xs sm:text-sm">
                  {totalAmount.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Amount in Words */}
      <div className="mb-6 p-3 sm:p-4 bg-gray-50 rounded-md border border-gray-200">
        <p className="text-xs sm:text-sm text-gray-600">Amount in words:</p>
        <p className="font-semibold text-gray-800 uppercase text-xs sm:text-sm">
          {amountInWords}
        </p>
      </div>

      {/* Signature */}
      <div className="text-right mb-6">
        <p className="text-gray-700 text-xs sm:text-sm">
          Signed: _____________________
        </p>
        <p className="text-xs text-gray-600 mt-1">for: {companyName}</p>
      </div>

      {/* Print Button */}
      <button
        onClick={handlePrint}
        className="w-full sm:w-auto bg-blue-600 text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200 print:hidden text-xs sm:text-sm"
      >
        Print Invoice
      </button>
    </div>
  );
}

export default ViewInvoice;
